module.exports = __webpack_public_path__ + "static/img/icon-upload-blue.cf8e26cc.png";